/**
 * Клиент GiperCRM. Вход — пропуск Supabase заголовком Bearer; рабочая область —
 * заголовок X-Project-Id (без него CRM деградирует до области всей организации).
 * CORS у CRM уже пускает *.unia.one, capacitor://localhost и localhost.
 */
import config from '@/lib/config';
import { getFreshAccessToken } from '@/lib/authToken';
import { ApiError, fetchWithTimeout, reasonOf } from '@/lib/http';
import { useProjectStore } from '@/store/project';

export async function crmFetch<T>(path: string, init: RequestInit = {}, повтор = true): Promise<T> {
  const token = await getFreshAccessToken(!повтор);
  const projectId = useProjectStore.getState().activeProjectId;
  const res = await fetchWithTimeout(`${config.CRM_API_URL}${path}`, {
    ...init,
    headers: {
      Accept: 'application/json',
      ...(init.body ? { 'Content-Type': 'application/json' } : {}),
      ...(init.headers as Record<string, string> | undefined),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(projectId ? { 'X-Project-Id': projectId } : {}),
    },
  });
  // Пропуск мог устареть между проверкой и сервером — один раз берём свежий.
  if (res.status === 401 && повтор) return crmFetch<T>(path, init, false);
  if (!res.ok) throw new ApiError(res.status, await reasonOf(res));
  return (await res.json()) as T;
}

// Воронки и сделки (этап 3) — src/api/pipeline.ts.
